module.exports = __webpack_public_path__ + "media/dashboard/assets/images/twitter-badge-9bab3edf9559259d9c712e4b9d0562a0.png";